module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.12.0.0.box.276.673.834.107.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.12.0.0.box.276.673.834.16.q.101"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.12.0.1.box.276.689.834.91.q.100"
    }
  }, [_vm._v("French Period")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.270.1073.1157.1235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.12.1.0.box.326.1073.1046.100.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _vm._v("RENE ROBERT CAVELIER, SIEUR DE LA SALLE "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1685-1687) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.270.1237.1156.357.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.1.0"
    }
  }), _vm._v("On April 9, 1682, Robert Cavelier de La Salle, after traveling down the Mississippi River to its mouth, made one of the largest territorial claims ever proclaimed by an individual. He claimed for France all the land drained by the Mississippi and its tributaries; in effect, all the territory lying between the Appalachian and Rocky Mountains and south of the Great Lakes to the Gulf of Mexico.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.2.box.271.1615.1156.316.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.2.0"
    }
  }), _vm._v("La Salle was a man of great strengths and monumental weaknesses. He was ambitious, courageous, intelligent, and energetic, but because he was also arrogant and overbearing he could never inspire loyalty, nor lead. So the vast territories of his discoveries and explorations slipped from him, and, in the end, to his country's rivals.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.3.box.271.1943.1155.312.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.3.0"
    }
  }), _vm._v("La Salle was born in Rouen, France, on November 22, 1643. In 1666 he went to Canada and became a fur trader and explorer. He discovered the Ohio and explored the upper Illinois country. Back in France, he secured a title of nobility and a permit for further explorations in the West, the Mississippi Valley in particular.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.4.box.347.2265.1079.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.4.0"
    }
  }), _vm._v("After descending the Mississippi, La Salle again went"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.13.1.0.box.270.390.1156.589.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _vm._v("\nto France to obtain supplies and followers to secure the territories he claimed. He proposed to the king not only to colonize the new territory, but since France and Spain were then at war, also to conquer adjoining Spanish lands, including Mexico. All he asked of the king was a vessel of thirty guns, ammunition, and authority to raise a force of two hundred men in France. Additional troops to conquer New Spain he would recruit from among the savages. Strange promises indeed for a man who had never led troops, or established governments, and who had repeatedly failed at the fur business.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.1.0.box.270.390.1156.1884.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.1.box.271.991.1155.635.q.60"
    }
  }, [_vm._v("The king furnished him not one vessel but four, along with more than two hundred colonists, thus equipping him for conquest as well as colonization. His first objective was to establish a settlement at the mouth of the Mississippi. Before the fleet was far at sea, La Salle was quarreling with his naval commander, Beaujeu, and it never ended. Most of the men sided with Beaujeu. La Salle's cold, reserved, moody disposition irritated his men, and they all but mutinied under his rigid discipline. He blamed others, particularly Beaujeu, for his \"bad luck,\" including missing the mouth of the Mississippi, obviously never realizing the difference between bad luck and bad judgment.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.2.box.270.1634.1153.359.q.60"
    }
  }, [_vm._v("After landing in the Matagorda Bay area of Texas in 1685, he established Fort Saint Louis, from which he made a series of expeditions to scout for Spaniards to the west, and then to search for the Mississippi. On January 12, 1687, he set out for Canada to secure supplies for his starving colony, and a few weeks later was murdered by his followers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.3.box.271.2015.1154.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.3.0"
    }
  }), _vm._v("Even in his blunders, La Salle served his country. In his failures in the fur trade in the North, he blazed the way for settlement and industry. His dream of finding a water route to the sea was sneered at, but he found one. Only a man dazzled by a dream possibly could have sold the king"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.14.1.0.box.274.401.1153.209.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v("\nof France on a project of conquering New Spain with an army of savages. His landing unintendedly beyond the Mississippi gave France a claim to present-day Texas. The fact that France did not follow up was not his fault.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.1.0.box.274.401.1157.425.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.274.620.1157.206.q.70"
    }
  }, [_vm._v("La Salle's vast dreams and energy gave promise of setting France off to a head start in North America, but without common sense and compassion he blew his opportunities, and those of France at that time.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.2.0.box.271.951.1158.1331.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.14.2.0.box.648.951.408.97.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _vm._v("SIEUR BARBIER "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1687-1689) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.2.1.box.275.1114.1154.370.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.1.0"
    }
  }), _vm._v("It is through Sieur Barbier that we get our last dim view of the fading prospects of a French colony in Texas. Barbier had come over with La Salle, and on La Salle's departure for Canada to seek help, he placed Barbier in charge of the French colony—as miserable, disappointed, scared, and hungry a group of people as might ever be called a \"colony.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.2.2.box.271.1493.1157.583.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.2.0"
    }
  }), _vm._v("When Barbier took command of Fort Saint Louis on January 12, 1687, he had about twenty persons under his command. They included, as best we can calculate, two friars, a priest, a surgeon, seven women and girls, several children, and some soldiers. About all he had left with him was hope—that La Salle would somehow make it through before it was too late, or that by a miracle some tardy ship would arrive with supplies. With unfriendly Indians about, and Spaniards rabidly jealous of any Frenchman who so much as looked toward Texas, no colony ever existed more dangerously.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.2.3.box.274.2084.1155.198.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.3.0"
    }
  }), _vm._v("One of the few things we know about Barbier is that he married while at Fort Saint Louis. One historian says the bride was \"one of the maidens recently brought out from France.\" Other accounts have it that she was a"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.1.0.box.275.388.729.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _vm._v("\nmaiden from one of the Indian tribes.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.1.0.box.273.388.1153.1114.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.1.box.273.443.1152.640.q.60"
    }
  }, [_vm._v("The colony survived only until the spring of 1689. There are two accounts, differing only in detail, of its bloody ending: While the French were engaged in peaceful pursuits along the bay, a large body of Indians fell upon them and murdered all but five, who escaped to the protection of friendly tribes. The other account says the colony was weakened by a smallpox epidemic, and when a large band of Indians asked admittance to the fort they were refused. When a number of the French came out to receive them in a cabin outside the palisade, the savages rushed inside and massacred all except four young people saved by Indian women.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.2.box.274.1095.1152.407.q.70"
    }
  }, [_vm._v("Barbier and his colonists were brave and made the supreme sacrifice for their country. On the basis of this colony, France claimed Texas for more than a century. But France did not follow up on this colonial enterprise. Staying power, as always, prevailed in the end. Barbier and his colonists were casualties of the fickle ambitions of kings, and the unpredictable hazards of savage-filled wildernesses.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96af5232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0006.vue
// module id = 60
// module chunks = 0